module.exports = __webpack_public_path__ + "img/sensor_node.98f66f4e.svg";